/**
 * plan-features.ts — client-side companion to worker/lib/plans.js.
 *
 * FeatureKey mirrors the boolean gates in the worker's `features` block. The
 * server is the source of truth (it 403s below the tier); this file only drives
 * the UI soft-lock — which control shows a lock, and the "upgrade to <tier>"
 * copy in its tooltip. Keep `minTier` in sync with plans.js.
 */

export type FeatureKey =
  | "restrictedAccess"
  | "internalComments"
  | "shareControls"
  | "shareExpiryControl"
  | "customBranding"
  | "whiteLabel"
  | "authorizedDomains"
  | "googleDriveImport";

/** Lowest plan that unlocks each feature (for the soft-lock tooltip copy). */
export const FEATURE_META: Record<FeatureKey, { minTier: string }> = {
  restrictedAccess:   { minTier: "Studio" },
  internalComments:   { minTier: "Studio" },
  shareControls:      { minTier: "Starter" },
  shareExpiryControl: { minTier: "Starter" },
  customBranding:     { minTier: "Studio" },
  whiteLabel:         { minTier: "Agency" },
  authorizedDomains:  { minTier: "Agency" },
  googleDriveImport:  { minTier: "Starter" },
};
